<div class="modal-header">
  <h3>
    <span>BlockTimes and Proximity </span>
    <button type="button" class="close close-lg pull-right" aria-label="Close"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h3>
</div>
<div class="modal-body row" style="overflow-y: auto; max-height: calc(100vh - 150px);">
  <div style="width:100%; padding-bottom: 12px; min-height: 300px; padding-left: 16px; padding-right: 16px;" class="clearfloat">

    <table style="border-spacing: 0px; border-collapse: separate; width: 100%;">
      <tr>
        <td style="padding-left: 18px; width: 236px;">
          <h4 class="control-row-name">Appointment Group Proximity:</h4>
        </td>
        <td>
          <div style="display: flex">
            <input type="text" [(ngModel)]="proximity" class="form-control" style="width: 80px" maxlength="4" pattern="-?[0-9]{1,4}"/>
            <h4 style="padding-left: 1rem" class="control-row-name">minutes</h4>
             <div style="padding-left: 60px; padding-top: 8px;">
                <small>Group appointments same day with n minutes proximity, same strategy all triggers with same destinators (e.g. same phone number for sms and same email address for emails) . Use 0 to group only with exactly same time. Use -1 to disable grouping</small>
             </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="rule-control-spacer"></div>
        </td>
      </tr>
    </table>

    <table style="width: 100%">
      <tr>
        <td style="width:70%;">

          <table style="border-spacing: 16px; border-collapse: separate; width: 100%">
            <tr>
              <td style="width: 236px;">
                <h4>Block Times:</h4>
              </td>
            </tr>
            <tr style="margin: 5px;" *ngFor="let blocktime of blockTimes; let i= index;">
              <td style="margin-left: 16px; width: 4%">
                <p-dropdown
                    name="blocktime{{i}}"
                    *ngIf="!blocktime.isDefault && !blocktime.isDate && !blocktime.isDay"
                    [options]="blockedType"
                    [(ngModel)]="blocktime.type"
                    (onChange)="onChange($event, blocktime)"
                    styleClass="form-control"
                    [style]="{'width':'15%', 'minWidth':'80px', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
          'height':'36px','padding-left': '16px', 'font-size': '10px', 'text-shadow': 'none'}">
                </p-dropdown>

                <p-dropdown
                    name="blocktime{{i}}"
                    *ngIf="!blocktime.isDefault && (blocktime.isDate || blocktime.isDay)"
                    [options]="blockedTypeForDateAndDay"
                    [(ngModel)]="blocktime.type"
                    (onChange)="onChange($event, blocktime)"
                    styleClass="form-control"
                    [style]="{'width':'15%', 'minWidth':'80px', 'background':'white', 'border' : '1px solid #cccccc', 'color' : 'black',
          'height':'36px','padding-left': '16px', 'font-size': '10px', 'text-shadow': 'none'}">
                </p-dropdown>
                <span *ngIf="blocktime.isDefault" style="width:15%">&nbsp;&nbsp;</span>
              </td>
              <td style="margin-left: 16px; width: 100px">
                <h4 class="control-row-name" *ngIf="!blocktime.isDate && !blocktime.isDay"
                    [ngClass]="{textDim: blocktime.type ==='Open'}"
                >{{blocktime.label}}:</h4>
                <input type="text"
                       class="form-control"
                       #datePicker{{i}}="bsDatepicker"
                       [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false , selectFromOtherMonth: true}"
                       bsDatepicker
                       [(ngModel)]="blocktime.value"
                       [placement]="'top'"
                       style="width: 100px;"
                       *ngIf="blocktime.isDate"
                />
                <input type="text"
                       class="form-control"
                       #dayPicker{{i}}="bsDatepicker"
                       [bsConfig]="{ dateInputFormat: 'MM/DD', containerClass: 'theme-dark-blue', showWeekNumbers: false , selectFromOtherMonth: true}"
                       bsDatepicker
                       [(ngModel)]="blocktime.value"
                       [placement]="'top'"
                       *ngIf="blocktime.isDay"
                       style="width: 100px;"/>
              </td>
              <td style="margin-left: 16px;" [hidden]="blocktime.type !=='Range'" class="custom-slider">
                <ngx-slider id="slider{{i}}" [(value)]="blocktime.range[0]" [(highValue)]="blocktime.range[1]"
                            [options]="options"></ngx-slider>
              </td>
              <td *ngIf="blocktime.type ==='Open'">
                Default used
              </td>
              <td *ngIf="blocktime.type ==='Closed'">
                Closed all day
              </td>
            </tr>
          </table>


        </td>
        <td style="padding-left: 20px; vertical-align: top; border-left : 1px dotted #cccccc;">
          <p>
            <b>Help:</b><br/><br/>
            <small>
              "Default" defines a standard period of the day (blue range) when it is allowed to send messages.
              If a "weekday", specific "date" (year specified) or "day" (recurring every year) is either "Closed" or
              set with a range different than the "Default" then that range is used for that day.
              If a day is "Closed" then no messages will be sent that day.
              <br/><br/>
              When calculating the time to send a message (trigger time) the strategy's trigger offset may initially be
              outside the allowed period. If the relative offset is set to multiple days before the appointment then
              these are considered "business days" so any day that is entirely "Closed" will be skipped. If offset is "1
              day before" for an appointment on Monday and weekend is "Closed" then the result is to send Friday.
              After finding the correct business day - if the calculated trigger time is outside allowed time (e.g.
              Friday has shorter open hours 1pm - 4pm) the final trigger time will be set to 1 hour and 15 minutes
              before the closing time of that day (e.g. 2:45 pm on Friday).
            </small>
          </p>

        </td>
      </tr>
    </table>

    <div>
      <button
          class="btn btn-primary" aria-hidden="true" (click)="addDate()"
          style="margin-left: 16px; margin-right: 16px; width: 80px">
        Add Date
      </button>

      <button
          class="btn btn-primary" aria-hidden="true" (click)="addDay()"
          style="margin-left: 6px; margin-right: 16px; width: 100px">
        Add Day
      </button>
    </div>
  </div>

</div>

<div class="modal-footer">
  <button
      class="btn btn-primary" aria-hidden="true" (click)="saveChanges()"
      [disabled]="isValid()"
      style="margin-right: 16px;">
    Update
  </button>
  <div class="pull-right">
    <button class="btn btn-default btn-cancel"
            (click)="onCancel()">
      Close
    </button>
  </div>
</div>
